import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from '../EpicAdministration/_theme';
import Navigation from './Navigation';
import PrivilegedView from '../EpicAdministration/components/PrivilegedView';
import EditorView from './Site/EditorView';
import { PERMISSIONS } from './_const';

const EpicAdministrationRoutes = () => {
	const { path } = useRouteMatch();
	const permissions = {
		roles: [PERMISSIONS.IMS_ROLE, PERMISSIONS.ECL_ROLE],
		privileges: [PERMISSIONS.ECL_PRIVILEGE],
	};

	return (
		<ThemeProvider theme={theme}>
			<Switch>
				<Route
					path={`${path}/Home`}
					exact
					render={() => (
						<PrivilegedView
							pageID='ECL_ADMINISTRATION_HOME'
							{...permissions}
						>
							<Navigation />
						</PrivilegedView>
					)}
				/>
				<Route
					path={`${path}/SiteSponsor`}
					exact
					render={props => (
						<PrivilegedView
							pageID='ECL_ADMINISTRATION_SITE_SPONSOR'
							{...permissions}
						>
							<EditorView {...props} />
						</PrivilegedView>
					)}
				/>
				<Route>
					<Redirect to={`${path}/Home`} />
				</Route>
			</Switch>
		</ThemeProvider>
	);
};

export default EpicAdministrationRoutes;
